import { Injectable } from '@angular/core';
import { DwAttributeType, DwContextDefinition, DwContextRepositoryService, DwControlType, DwCustomContextBase, DwCustomContextDefinition, 
         DwExpressionAttribute, DwExpressionCompareType, DwQuery, DwQueryHelper, DwSecurityTopics, DwSecurityUserService } from '@devwareapps/devware-cap';
import { Permits2PermitEntity, PermitsV2MetaDataItemNames, PermitsV2MetaDataLookups } from '../meta-data/permitsv2-meta-data.service';

@DwCustomContextDefinition({
    keyName: 'permitV2InspectionCountContext',
    display: 'Permit V2 - Inspection Counts',
    isGlobal: false,
    parentItem: PermitsV2MetaDataItemNames.Permits2Permit
})
@Injectable()
export class PermitV2InspectionCountContextService extends DwCustomContextBase {

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (resolvedContext => {
            const permit: Permits2PermitEntity = resolvedContext?.data;
            return { InspectionCount : permit?.Permits2roInspections?.length || 0 };
        });
        contextDef.attributes = [];
        var hasPermissionAttr : DwExpressionAttribute = this.addProperty(contextDef.attributes, 
                                                                        'InspectionCount', 'Inspection Count', 
                                                                         DwAttributeType.Integer, DwControlType.NumericTextBox);
    }

}